import React from 'lib/react';
import PropTypes from 'prop-types';
import ExpandableCardList from 'commonComponents/expandableCardList';

/** Component to render the Report details in card format for Order History Page (Subscription variant) */
function ReportsTableSubscription({
  reportDetailsList, ...rest
}) {
  return (
    <ExpandableCardList
      dataList={reportDetailsList}
      rowKey="rowKey"
      {...rest}
    />
  );
}

ReportsTableSubscription.propTypes = {
  reportDetailsList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default ReportsTableSubscription;
